<template>
  <div class="wrapper">
    <div class="header">
      <span>Biểu đồ số lượng nhân sự theo từng khối</span>
    </div>
    <div class="row">
      <div class="wrapper_left col-12 col-lg-6">
        <div class="option_top">
          <div class="text">
          {{getFootName("SOFTWARE_DEVELOPMENT")}}
          </div>
          <div style="height: 250px">
            <v-chart :option="option_top" autoresize />
          </div>
          <hr>
          <div style="height: 250px">
            <v-chart :option="option_position_all" autoresize />
          </div>
          <hr>
          <div style="height: 250px">
            <v-chart :option="option_position_department" autoresize />
          </div>
        </div>
        <!-- <div class="option_bot">
          <div class="text">
           {{getFootName("SOFTWARE_DEVELOPMENT_2")}}
          </div>
          <div style="height: 250px">
            <v-chart :option="option_bot" autoresize />
          </div>
        </div> -->
      </div>
      <div class="wrapper_right col-12 col-lg-6">
        <div class="option_top">
          <div class="text">
            {{getFootName("INTENAL_SERVICE")}}
            </div>
          <div style="height: 350px">
            <v-chart style="height: 350px" :option="option_right" autoresize />
          </div>
        </div>
        <div class="option_bot">
          <div class="text">
            {{getFootName("BUSINESS_BLOCK")}}
            </div>
          <div style="height: 250px">
            <v-chart :option="biz_chart_option" autoresize />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  DatasetComponent,
  GridComponent,
  VisualMapComponent,
} from "echarts/components";
import VChart from "vue-echarts";
use([
  DatasetComponent,
  GridComponent,
  VisualMapComponent,
  BarChart,
  CanvasRenderer,
]);
import { mapGetters } from "vuex";

export default {
  name: "",
  components: {
    VChart,
  },
  data() {
    return {
      //Khoi phat trien so 1
      option_top: {
        dataset: {
          source: [],
        },
        grid: { containLabel: true },
        xAxis: {
          interval: 10,
          splitLine: {
            lineStyle: {
              type: [5, 5],
              dashOffset: 5,
            },
          },
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        visualMap: {
          orient: 'horizontal',
          show: false,
          left: 'center',
          min: 0,
          max: 200,
          dimension: 0,
          inRange:{color:[]}
        },
        series: [
          {
            barMaxWidth: 17,
            type: "bar",
            encode: {
              x: "amount",
              y: "division",
            },
            label: {
              show: true,
              color: "#303c54",
              position: "right",
              fontWeight: "bold",
              fontFamily:
                  "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            },
            itemStyle: {
              normal: {
                barBorderRadius: [20]
              },
            },
          },
        ],
      },

      //Khoi phat trien so 2
      option_bot: {
        dataset: {
          source: [],
        },
        grid: { containLabel: true },
        xAxis: {
          interval: 10,
          splitLine: {
            lineStyle: {
              type: [5, 5],
              dashOffset: 5,
            },
          },
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        visualMap: {
          orient: 'horizontal',
          show: false,
          left: 'center',
          min: 0,
          max: 200,
          dimension: 0,
          inRange:{color:[]}
        },
        series: [
          {
            barMaxWidth: 17,
            type: "bar",
          
            encode: {
              x: "amount",
              y: "division",
            },
            label: {
              show: true,
              color: "#303c54",
              position: "right",
              fontWeight: "bold",
              fontFamily:
                  "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            },
            itemStyle: {
              normal: {
                barBorderRadius: [20],
              },
            },
          },
        ],
      },

      //Khoi dich vu
      option_right: {
        dataset: {
          source: [],
        },
        grid: { containLabel: true },
        xAxis: {
          interval: 1,
          splitLine: {
            lineStyle: {
              type: [5, 5],
              dashOffset: 5,
            },
          },
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        visualMap: {
          orient: 'horizontal',
          show: false,
          left: 'center',
          min: 0,
          max: 200,
          dimension: 0,
          inRange:{color:[]}
        },
        series: [
          {
            barMaxWidth: 17,
            type: "bar",
            colorBy: "data",
            encode: {
              x: "amount",
              y: "division",
            },
            label: {
              show: true,
              color: "#303c54",
              position: "right",
              fontWeight: "bold",
              fontFamily:
                  "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            },
            itemStyle: {
              normal: {
                barBorderRadius: [20],
              },
            },
          },
        ],
      },

      // position
      option_position_all: null,
      option_position_department: null,

      // biz 
      biz_chart_option: {
        dataset: {
          source: [],
        },
        grid: { containLabel: true },
        xAxis: {
          interval: 1,
          splitLine: {
            lineStyle: {
              type: [5, 5],
              dashOffset: 5,
            },
          },
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        visualMap: {
          orient: 'horizontal',
          show: false,
          left: 'center',
          min: 0,
          max: 200,
          dimension: 0,
          inRange:{color:[]}
        },
        series: [
          {
            barMaxWidth: 17,
            type: "bar",
            colorBy: "data",
            encode: {
              x: "amount",
              y: "division",
            },
            label: {
              show: true,
              color: "#303c54",
              position: "right",
              fontWeight: "bold",
              fontFamily:
                  "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
            },
            itemStyle: {
              normal: {
                barBorderRadius: [20],
              },
            },
          },
        ],
      },
    };
  },
  async created() {
    this.getPositionChartData();
    await this.getDivisionData();
  },
 

  computed: {
    ...mapGetters({
      divisions: "dashboard/divisions",
      foots: "commons/foots",
      commonDivisions: "commons/divisions",
      divisionColors: "dashboard/divisionColors"
    }),
  },

  methods: {
    async getDivisionData() {
      await this.$store.dispatch("dashboard/getCountDivision");
      const value = this.divisions;
      const colors = this.divisionColors;
      const nameOfDivisions = {};
      this.commonDivisions.forEach((divisionItem) => {
        nameOfDivisions[divisionItem.code] = divisionItem.name;
      });
      
      delete value["OTHER"];
      for (const key in value) {
        if (Object.hasOwnProperty.call(value, key)) {
          const element = value[key];
          let maxValue = 0;
          const employs = Object.keys(element).map((item) => {
            if (maxValue < element[item]) { maxValue = element[item]; }
            return [
              element[item],
              nameOfDivisions[item]
            ];
        });
          this.setDivisionData(key, employs, maxValue, colors[key]);
        }
      }
    },
    setDivisionData(division, data, max, color = null) {
      data = data.reverse();
      switch (division) {
        case "INTENAL_SERVICE":
          this.option_right.dataset.source = data;
          this.option_right.visualMap.max = max;
          this.option_right.visualMap.inRange.color = [
            `${color}99`, `${color}ff`
          ];
          break;
        case "SOFTWARE_DEVELOPMENT":
          this.option_top.dataset.source = data;
          this.option_top.visualMap.max = max;
          this.option_top.visualMap.inRange.color = [
            `${color}80`, `${color}ff`
          ];
          break;
        case "SOFTWARE_DEVELOPMENT_2":
          this.option_bot.dataset.source = data;
          this.option_bot.visualMap.max = max;
          this.option_bot.visualMap.inRange.color = [
            `${color}80`, `${color}ff`
          ];
          break;
        case "BUSINESS_BLOCK":
          this.biz_chart_option.dataset.source = data;
          this.biz_chart_option.visualMap.max = max;
          this.biz_chart_option.visualMap.inRange.color = [
            `${color}99`, `${color}ff`
          ];
          break;
        default:
      }
    },
    async getPositionChartData() {
      try {
        const res = await this.$store.dispatch("dashboard/getPositionAnalytics");
        const position_chart_colors = res.data.position_chart_colors;
        const data = (res.data.all || []).map(value => {
          return {
            ...value,
            value: value.value || '-',
            itemStyle: {
              color: position_chart_colors[value.id],
            }
          }
        });
        this.option_position_all = {
          legend: {
            // align: "left",
            selectedMode: false,
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          textStyle: {
            fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
          },
          series: [
            {
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              top: '20px',
              label: {
                show: true,
                position: "inside",
                formatter: "{c}",
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: 14,
              },
              labelLine: {
                show: false
              },
              data,
            },
          ],
        };

        const department_positions = res.data.department_positions || [];

        const yAxisData = [];
        const series = [];

        (res.data.departments || []).forEach(department => {
          yAxisData.push(department.name);
        });

        (res.data.positions || []).forEach((position) => {
          const data = [];
          
          (res.data.departments || []).forEach(department => {
            const department_position = department_positions.find(el => el.department_code === department.code && el.position_id === position.id);
            data.push(department_position?.quantity || '-');
          });
          
          series.push({
            name: position.name,
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            barMaxWidth: 17,
            emphasis: {
              focus: 'series'
            },
            data,
            itemStyle: {
              color: position_chart_colors[position.id],
            }
          })
        });

        const stackInfo = {};
        for (let i = 0; i < series[0].data.length; ++i) {
          for (let j = 0; j < series.length; ++j) {
            const stackName = series[j].stack;
            if (!stackName) {
              continue;
            }
            if (!stackInfo[stackName]) {
              stackInfo[stackName] = {
                stackStart: [],
                stackEnd: []
              };
            }
            const info = stackInfo[stackName];
            const data = series[j].data[i];
            if (data && data !== '-') {
              if (info.stackStart[i] == null) {
                info.stackStart[i] = j;
              }
              info.stackEnd[i] = j;
            }
          }
        }
        for (let i = 0; i < series.length; ++i) {
          const data = series[i].data;
          const info = stackInfo[series[i].stack];
          for (let j = 0; j < series[i].data.length; ++j) {
            const isEnd = info.stackEnd[j] === i;
            const border = isEnd ? 20 : 0;
            data[j] = {
              value: data[j],
              itemStyle: {
                borderRadius: [0, border, border, 0]
              }
            };
          }
        }
        
        this.option_position_department = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // Use axis to trigger tooltip
              type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          textStyle: {
            fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
          },
          xAxis: {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yAxisData,
          },
          series,
        }
      } catch (error) {
        
      }
    },
    getFootName(foot) {
      return this.foots.find((footItem) => {
              return footItem.code == foot;
      })?.name 
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 20px;
  position: relative;
  background: #ffffff;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 10px 20px;
  height: 100%;
  .wrapper_left {
    border-right: 2px solid #efefef;
  }
  .header {
    margin-top: 15px;
    font-family: "-apple-system,BlinkMacSystemFont," Segoe UI ",Roboto,"
      Helvetica Neue ",Arial," Noto Sans ",sans-serif," Apple Color Emoji ","
      Segoe UI Emoji "," Segoe UI Symbol "," Noto Color Emoji "";
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 28px;
    color: #303c54;
  }
  .text {
    background: #ededed;
    border: 1px solid #ededed;
    border-radius: 10px;
    padding: 15px 20px;
    font-weight: 700;
    font-size: 16px;
    color: #303C54;
  }
}
</style>